<template>
  <header class="main-menu flex flex-between fixed w100 top0 z10 bg-white z9999"
          :class="{'mobile-menu': isMobileMenu}">

    <router-link class="logo absolute" to="/">
      <img class="w100"
           src="../../assets/logo.png"
           alt="logo">
    </router-link>

    <nav class="items z9999 hide">
      <router-link :to="'/' + key"
                   class="uppercase"
                   v-for="(item, key) in content.menu"
                   :key="key">
        <span @click="Set_Route">{{ item }}</span>
      </router-link>

      <!-- LANGUAGES / FLAGS -->
      <nav class="flags absolute hide">
        <ul class="flex">
          <li class="pointer"
              v-for="(item,key) in svg.flags"
              :key="key">
            <i v-if="key !== lang" v-html="item"></i>
          </li>
        </ul>
      </nav>
    </nav>


    <!-- FACEBOOK -->
    <nav class="social flex absolute z999">
      <a :href="socialMedia.fb" target="_blank">
        <img src="../../assets/fb.png" alt="fb">
      </a>
    </nav>

    <div class="menu-icon z9999 absolute"
         @click="ShowMobileMenu">
      <svg width="32px"
           height="22px"
           viewBox="274 37 32 22">
        <g id="Group-4"
           stroke-width="1"
           fill="none"
           fill-rule="evenodd"
           transform="translate(275.000000, 38.000000)">
          <path d="M0,1 L29.367867,1" class="line" id="line-1" stroke-width="2"></path>
          <path d="M0,10 L29.367867,10" class="line" id="line-2" stroke-width="2"></path>
          <path d="M0,18 L29.367867,18" class="line" id="line-3" stroke-width="2"></path>
        </g>
      </svg>
    </div>

  </header>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'BaseMainMenu',
    data () {
      return {
        isMobileMenu: false
      }
    },
    computed: {
      ...mapGetters([
        'lang',
        'svg',
        'content',
        'socialMedia'
      ])
    },
    methods: {
      ShowMobileMenu () {
        this.isMobileMenu = !this.isMobileMenu
      },
      Set_Route () {
        this.isMobileMenu = false
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  /*@import "../../styles/var";*/
  .main-menu {
    height: 70px;
    padding: 5px;
    border-bottom: 1px solid lightgrey;
    transition: all 0.3s ease-in-out;
    .logo,
    .menu-icon {
      transition: transform 0.3s ease-in-out;
      padding: 6px;
    }
    .logo {
      border: none !important;
      img {
        width: 70px;
      }
    }
    .menu-icon {
      height: 40px;
      margin-top: 14px;
      right: 10px;
      svg g {
        stroke: #000000;
        .line {
          transition: all 0.3s ease-in-out;
        }
      }
    }
    .items {
      width: 680px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      a {
        height: 22px;
        margin-top: 22px;
        display: block;
        font-weight: 400;
        color: black;
        opacity: 0.8;
        &:hover:not(.router-link-active) {
          color: #368d00;
        }
      }
    }

    @media only screen and (min-width: 320px) {
      .items,
      .social {
        display: none;
      }
      .items {
        a {
          font-size: 1.6rem;
        }
      }
      .flags {
        right: 60px;
        top: 20px
      }
    }

    @media only screen and (min-width: 768px) {
    	.logo {
        margin-left: 16px;
      }
    }

    @media only screen and (min-width: 884px) {
      .menu-icon {
        display: none;
      }
      nav {
        width: 760px;
      }
      .items {
        display: flex;
        a {
          font-size: 1.4rem;
        }
        ul {
          display: flex;
          width: 100%;
        }
      }
      .flags {
        right: 64px;
        top: 22px;
        opacity: 0.7;
        ul {
          align-items: center;
          justify-content: space-between;
        }
        &:hover {
          opacity: 1;
        }
      }
      .social {
        display: flex;
        width: 32px;
        top: -4px;
        right: 24px;
        a {
          img {
            width: 32px;
          }
        }
      }
    }

    @media only screen and (min-width: 1024px) {
      .logo {
        margin-left: 20px;
      }
      .items {
        width: 78%;
        max-width: 994px;
        padding-left: 0;
        a {
          font-size: 1.6rem;
        }
      }
    }

    @media only screen and (min-width: 1366px) {
      .logo {
        left: 60px;
      }
    }
  }

  .mobile-menu {
    height: 100%;
    .title {
      display: none;
    }
    .items {
      position: absolute;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .menu-icon {
      #line-1 {
        transform: rotate(45deg);
        transform-origin: 4px 5px;
      }
      #line-2 {
        transform: rotate(-45deg);
        transform-origin: 15px 10px;
      }
      #line-3 {
        opacity: 0;
      }
    }
  }

  .router-link-active {
    border-bottom: 1px solid #368d00;
    span {
      color: #368d00;
      font-weight: 500;
    }
  }


</style>




// WEBPACK FOOTER //
// src/components/molecules/BaseMainMenu.vue